import React, { useContext } from 'react';
import intl from 'react-intl-universal';
import VectorIcon from '@/assets/PaymentDlg/vector.svg';
import { PayContext } from './ContextProvider';

const MoreStorePlan = () => {
  const tip = intl.getHTML('account.FoxitStore');
  const { store } = useContext(PayContext);

  const mountNode = domNode => {
    if (!domNode) return;
    document.querySelector('#visit_foxit_store_link').onclick = () => {
      store.userStore.goFoxitStore();
    };
  };

  return (
    <div className='visit-store-box'>
      <img src={VectorIcon} />
      <div ref={mountNode}>{tip}</div>
    </div>
  );
};
export default MoreStorePlan;